{
  "sidenavMenuCloseTooltip": "Fermer le menu",
  "sidenavMenuLockTooltip": "Cliquer pour verrouiller le menu",
  "toggleSideNav": "Activer/désactiver le menu de navigation latéral"
}
